import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { Observable } from 'rxjs'

@Injectable()
export class OntologyCorrelationInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!/\/ontology\/api\//.test(request.url) || request.headers.has('X-Request-ID')) {
      return next.handle(request)
    }
    const id = Array.from(crypto.getRandomValues(new Uint8Array(16)), (value) =>
      value.toString(16).padStart(2, '0')
    ).join('')
    return next.handle(request.clone({ setHeaders: { 'X-Request-ID': id } }))
  }
}
